import React from 'react';
import { useCoreTranslations } from '../translations';
import styles from './SessionOutOfDateDialog.module.css';

interface SessionOutOfDateDialogProps {
  isImpersonating: boolean;
}

const SessionOutOfDateDialog: React.FC<SessionOutOfDateDialogProps> = ({ isImpersonating }) => {
  const i18n = useCoreTranslations();

  return (
    <div className={styles.modalContainer}>
      <div className={styles.modalContent}>
        {isImpersonating ? 'Fixing your session...' : i18n.sessionOutOfDateLogout}
      </div>
    </div>
  );
};

export default React.memo(SessionOutOfDateDialog);
